import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { EssenceBalance } from '#src/components/balance/EssenceBalance/index.tsx';
import { GemsBalance } from '#src/components/commonGame/GemsBalance/index.tsx';
import { ANY_SPORT_SERIES_MARKET_COMMON_PACKS } from '#src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { getCommonCardShardsCount } from '#src/lib/currentUser/index.tsx';
import { COMMON_GAME_SET } from '#src/set/index.ts';

// TODO:  get active card set from API
const ACTIVE_CARD_SET_SLUG = COMMON_GAME_SET.cardSet.activeSlug;

export const MobileSeriesUserCurrencies = () => {
  const { generateSportContextPath } = useSportContext();
  const { currentUser } = useCurrentUserContext();

  const shardsBalance = getCommonCardShardsCount(
    currentUser,
    ACTIVE_CARD_SET_SLUG
  );

  const showGems = !currentUser?.anyUserSportProfile?.proUnlocked;

  return (
    <Horizontal>
      {!!showGems && (
        <GemsBalance
          balance={currentUser?.gemsBalances[0]?.amount || 0}
          variant="vertical"
        />
      )}
      <EssenceBalance
        variant="vertical"
        value={shardsBalance || 0}
        rarity={Rarity.common}
        cardSetSlug={ACTIVE_CARD_SET_SLUG}
        to={generateSportContextPath(ANY_SPORT_SERIES_MARKET_COMMON_PACKS)}
      />
    </Horizontal>
  );
};
